import { Instagram, Star, Phone, MapPin, MessageCircle } from "lucide-react";
import { IMG, INSTAGRAM_URL, GOOGLE_URL, waLink, PHONE_DISPLAY } from "@/lib/site";

const NAV = [
  { label: "Serviços", href: "#servicos" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Portfólio", href: "#portfolio" },
  { label: "Avaliações", href: "#avaliacoes" },
  { label: "Atendimento", href: "#atendimento" },
];

const SERVICES = ["Box para Banheiro", "Espelhos Sob Medida", "Vidro Temperado", "Manutenção de Box", "Portas de Vidro"];

export const Footer = () => (
  <footer className="relative bg-[#012a60] text-white pt-20 pb-10">
    <div className="grain" />
    <div className="relative max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <img src={IMG.logoFull} alt="Vidraçaria Gabibox" className="h-14 w-auto object-contain mb-5" />
          <p className="text-sm text-white/60 leading-relaxed">
            Especialistas em vidro temperado, box para banheiro e espelhos sob medida na Grande
            Florianópolis.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
              className="grid place-items-center h-10 w-10 rounded-full bg-white/10 hover:bg-[#55c0e0] hover:text-[#012a60] transition-colors">
              <Instagram size={18} />
            </a>
            <a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer" aria-label="Google"
              className="grid place-items-center h-10 w-10 rounded-full bg-white/10 hover:bg-[#55c0e0] hover:text-[#012a60] transition-colors">
              <Star size={18} />
            </a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
              className="grid place-items-center h-10 w-10 rounded-full bg-white/10 hover:bg-[#25D366] transition-colors">
              <MessageCircle size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest text-[#55c0e0] mb-5">Navegação</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-sm text-white/70 hover:text-white transition-colors">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest text-[#55c0e0] mb-5">Serviços</h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s}>
                <a href="#servicos" className="text-sm text-white/70 hover:text-white transition-colors">{s}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest text-[#55c0e0] mb-5">Contato</h4>
          <ul className="space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin size={17} className="text-[#55c0e0] mt-0.5 shrink-0" />
              São José • Florianópolis • Grande Florianópolis
            </li>
            <li>
              <a href="tel:+5548996889862" className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone size={17} className="text-[#55c0e0] shrink-0" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors">
                <Instagram size={17} className="text-[#55c0e0] shrink-0" /> @vidracariagabibox
              </a>
            </li>
          </ul>
          <a href={waLink()} target="_blank" rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#55c0e0] px-5 py-3 text-sm font-bold text-[#012a60] hover:bg-white transition-colors">
            <MessageCircle size={16} /> Solicitar Orçamento
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50">© {new Date().getFullYear()} Vidraçaria Gabibox. Todos os direitos reservados.</p>
        <p className="text-xs text-white/40">Vidros temperados • Box • Espelhos • São José & Florianópolis</p>
      </div>
    </div>
  </footer>
);
